<template>
  <slot>
    <router-view/>
  </slot>
</template>